import { ReactElement } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export interface FaqInterface {
  q: string;
  a: string;
}

interface Props {
  faqs: FaqInterface[];
}

export const FaqList = ({ faqs }: Props): ReactElement => (
  <div className="max-w-180 mx-auto flex flex-col gap-3">
    {faqs.map(({ q, a }) => (
      <details
        key={q}
        className="group bg-background-tertiary rounded-sm px-5"
      >
        <summary className="flex gap-x-2 items-center justify-between py-5 w-full text-left cursor-pointer list-none [&::-webkit-details-marker]:hidden">
          <h3 className="flex-1 font-grotesque text-[1.75rem] leading-8 font-semibold text-white">
            {q}
          </h3>
          <ChevronDownIcon
            className="w-6 h-6 text-white shrink-0 group-open:rotate-180 transition-transform"
            aria-hidden="true"
          />
        </summary>
        <div className="pt-2 pb-5">
          <p className="text-base leading-6 text-grey-200">{a}</p>
        </div>
      </details>
    ))}
  </div>
);
